import { render } from "./ball.svg?vue&type=template&id=42ba695e"
const script = {}
script.render = render

export default script